import Fr from "../../assets/images/flags/fr.svg?react";

export default Fr;
